<template>
  <div class="markets">
      <div class="banner"></div>
      <div class="content">
        <van-list v-model="loading" :finished="finished" finished-text="已经到底" @load="onLoad">
          <div class="content-wrap">
            <div class="content-wrap-item" v-for="(item, index) in imgsArr" :key="index" @click="itemClick(item)">
              <img :src="item.imgs.split(',')[0]" alt="" :style="{ height: item.imgHeight}">
              <div class="content-wrap-item-text">
                <span>{{ item.title }}</span>
                <span>{{ item.author ? `作者: ${item.author}` : ''}}</span>
                <span>{{ item.desc }}</span>
              </div>
            </div>
          </div>
        </van-list>
      </div>
      <div class="pre-page">
        <img src="/static/bytx/public/welfare_back_btn.svg" @click="back">
      </div>
      <div class="bot" v-show="botShow">
        <div class="bot-box">
          <div class="bot-box-left" @click="go">
            <img src="/static/bytx/public/welfare_detail_donate_btn.svg">
          </div>
          <div class="bot-box-right" @click="clickShare">
            <img src="/static/bytx/public/welfare_detail_share_btn.svg">
          </div>
        </div>
      </div>
      <shade v-show="shadeShow" @close="close" :imgObj="imgObj" :shadeShow="shadeShow"></shade>
      <van-overlay :show="shareShow" @click="shareShow = false">
        <div class="share-box">
          <div class="block">
            请点击 “...”，再点击发送给朋友 | <span>知道啦</span>
          </div>
        </div>
      </van-overlay>
    </div>
</template>

<script>
import Interface from "../../../../util/interface";
import vueWaterfallEasy from 'vue-waterfall-easy';
import shade from "../component/shade";
import loveMarketSkeleton from "@/skeleton/loveMarketSkeleton"
import {LocationHref} from '@/util/common'

export default {
  name: "index",
  components: {
    vueWaterfallEasy,
    shade,
    loveMarketSkeleton
  },
  data() {
    return {
      imgsArr: [],
      index: 1,
      botShow: true,
      shadeShow: false,
      shareShow: false,
      imgObj: {},  // 点击的某个瀑布流
      loading: false,
      waterfallDeviationHeight: [], // 瀑布流高度偏移量
      waterFullList: [],
      itemBottom: 10,
      imgWidth: 0,
      record_id: 0,
      finished:false
    }
  },
  created() {
    this.init()
    Interface.getData('post',Interface.footprint, {
      id: 0,
      type: 58,
      content_type: 0,
      page_type: 6,
      source_type: 0,
      parent_id: 0,
      record_id: 0,
      title: '爱心集市列表'
    }).then( (res) => {
      if (res.code == 0) {
        this.record_id = res.data.record_id
      }
    })


  },
  beforeRouteLeave(to, from, next) {
    if (this.record_id) {
      Interface.mFootPrint(0, 58,0, 6, 0, 0,this.record_id,'爱心集市')
    }
    next()
  },
  methods: {
    onLoad() {
      this.finished = false
      this.init()
    },
    init() {
      this.loading = true
      Interface.getData('get', Interface.public.list, {pageSize: 10, page: this.index}).then((res) => {
        if (res.code == 0) {
          this.loading = false
          for (let i = 0; i < res.data.list.length; i++) {
            this.imgsArr.push(res.data.list[i])
          }
        }
      })
      this.index++
    },
    // 瀑布流图片点击
    itemClick(item) {
      this.imgObj = item
      this.shadeShow = true
      Interface.footPrint(39,item.id,0,"点击爱心集市某个项目")
    },
    // 关闭图片查看框
    close() {
      this.shadeShow = false
    },
    // 跳转到献爱心页面
    go() {
      LocationHref(Interface.url.show_love_url)
      Interface.footPrint(40,0,0,"点击爱心集市列表献爱心按钮")
    },
    back() {
      this.$router.push({name:'welfare-zone'})
    },
    clickShare() {
      this.shareShow = true
      Interface.footPrint(41,0,0,"点击爱心集市列表分享按钮")
    },
    linkTo(item){
      LocationHref(item.target_url)
    },
    // 瀑布流布局
    waterfallFlowLayout(itemData, len, index){
      let shortIndex = this.getShortestCol()
      itemData.top = this.waterfallDeviationHeight[shortIndex] + 16
      if (len % 2 == 1 && index == len - 1) {
        if (shortIndex == 1) {
          itemData.left = shortIndex * (this.imgWidth + 11)
        } else {
          itemData.left = 0
        }
      } else {
        itemData.left = shortIndex * (this.imgWidth + 11)
      }
      this.waterfallDeviationHeight[shortIndex] += itemData.height + this.itemBottom;
    },
    getShortestCol() {
      const shortest = Math.min.apply(null, this.waterfallDeviationHeight);
      return this.waterfallDeviationHeight.indexOf(shortest);
    }
  }
}
</script>
<style lang="scss">
@import "./index.scss";
</style>



// WEBPACK FOOTER //
// src/views/community/welfare-zone/donation/index.vue